import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am{" "}
            <span className="purple">Muhamamd Manan Bari </span>
            from <span className="purple"> Faisalabad, Pakistan.</span>
            <br />I am a junior pursuing B.S in Software Engineering in vu
            Faisalabad.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Play Snooker
            </li>
            <li className="about-activity">
              <ImPointRight /> Play With Code
            </li>
            <li className="about-activity">
              <ImPointRight /> Play PUBG
            </li>
          </ul>

          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">azadpunchy</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
